<template>
  <div class="item-cost">
    <div class="num-box">
      <div class="num">{{ value }}</div>
      <div class="unit">{{ unit }}</div>
    </div>
    <div class="tips">{{ label }}</div>
    <div class="icon-wrap">
      <el-popover trigger="hover" v-model="show_popover">
        <i slot="reference" class="el-icon-warning" />
        <div v-if="show_popover" class="pop-tips" v-html="tips">
        </div>
      </el-popover>
    </div>
  </div>
</template>
<script>
import { Popover as ElPopover } from 'element-ui'
export default {
  props: ['unit', 'label', 'tips', 'value'],
  data() {
    return {
      show_popover: false,
    }
  },
  components: { ElPopover }
}
</script>
<style lang="scss">
$main_color: #2F419B;
$tip_color: #17B6A1;
;

.item-cost {
  font-family: PingFang SC;
  flex: 1;
  height: 100%;
  color: $main_color;
  display: flex;
  flex-direction: column;
  justify-content: center;
  row-gap: 0.2rem;
  position: relative;

  @at-root {
    .pop-tips {
      color: $tip_color;
      font-size: 12px;
      max-width: 480px;

    }
  }

  .icon-wrap {
    position: absolute;
    width: 1rem;
    height: 1rem;
    top: 0.5rem;
    right: 0.5rem;
    font-size: 18px;
    cursor: pointer;
    text-align: center;
    color: $tip_color;
  }

  .tips {
    font-weight: bold;
    font-size: 12px;
    line-height: 1.6;
    text-align: center;
  }

  .num-box {
    display: flex;
    align-items: baseline;
    justify-content: center;
    column-gap: 0.2rem;
    color: $main_color;

    .num {
      font-weight: bold;
      font-size: 18px;
      line-height: 1.6;
    }

    .unit {
      font-size: small;
    }
  }
}
</style>